import type { InventoryItemMetricChip } from './inventory-item-list-types.js';
import { INVENTORY_STOCK_LEVEL_LABELS } from './inventory-item-stock-level/index.js';

export const INVENTORY_ITEM_METRIC_CHIP_LABELS: Record<InventoryItemMetricChip, string> = {
  ...INVENTORY_STOCK_LEVEL_LABELS,
  SHORT: 'Short',
  INBOUND: 'Inbound',
  OUTBOUND: 'Outbound',
};
